import {environment} from '../environment'
import axios from 'axios';
import { useBasicAuth } from '../../shared/components/auth/withBasicAuth';

const urlAPI = environment.getApi('protecaoIntegralShapeFile');

export const check = () => useBasicAuth.checkToken();

export const findGeologiaShapeProtecaoIntegralFileById = (id) => 
  axios.get(urlAPI + "/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllGeologiaShapeProtecaoIntegralFile = () => 
  axios.get(urlAPI + "/findAll", environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllGeologiaShapeProtecaoIntegralFileByDeleted = (value) => 
  axios.get(urlAPI + "/deleted/" + value , environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const updateGeologiaShapeProtecaoIntegralFile = (fileRequest) => 
  axios.post(urlAPI + "/updateGeologiaShapeFileProtecaoIntegral" , JSON.stringify(fileRequest), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });
  

export const deleteGeologiaShapeProtecaoIntegralFile = (id) => 
  axios.delete(urlAPI + "/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });